module.exports = __webpack_public_path__ + "img/best.42229a27.png";